/**
 * Motion presets for Image to Video → Customize.
 *
 * Tapping a chip fills the prompt box (the user can still edit it). These are
 * plain user-visible phrases, not the proprietary template prompts, so they
 * live in the client for now; move them to the CMS if the list needs to be
 * edited without a release.
 */
export interface MotionPreset {
  id: string;
  label: string;
  text: string;
}

export const MOTION_PRESETS: readonly MotionPreset[] = [
  {
    id: 'zoom-in',
    label: 'Zoom in',
    text: 'Slowly zoom in on the subject with smooth camera movement, keeping the focus on the face, creating a cinematic and emotional feel.',
  },
  {
    id: 'orbit',
    label: 'Orbit',
    text: 'The camera slowly orbits around the subject with smooth, steady motion while the subject stays still and in focus.',
  },
  {
    id: 'hair-wind',
    label: 'Hair in the wind',
    text: 'A gentle breeze moves the hair and clothing softly, with subtle natural motion and a calm, dreamy atmosphere.',
  },
  {
    id: 'smile-blink',
    label: 'Smile & blink',
    text: 'The subject blinks naturally and breaks into a soft, warm smile, with small natural head movements.',
  },
  {
    id: 'cinematic-pan',
    label: 'Cinematic pan',
    text: 'A slow cinematic pan across the scene with gentle parallax depth, soft light and a smooth film-like feel.',
  },
];
